export const getCoverImage = clientData => {
  if (!(clientData != null && clientData.coverImage)) {
    return undefined;
  }
  try {
    const stored = JSON.parse(clientData.coverImage);
    if (!stored.uri || !stored.width || !stored.height) {
      return undefined;
    }
    return {
      uri: stored.uri,
      width: stored.width,
      height: stored.height
    };
  } catch (e) {
    return undefined;
  }
};
//# sourceMappingURL=get-cover-image.js.map